export enum Status {
  Abandoned = 'abandoned',
  Booked = 'booked',
  Cancelled = 'cancelled',
  Closed = 'closed',
  Requested = 'requested',
}
